import Prev from './Prev'

export default Prev
// eslint-disable-next-line import/export
export * from './Prev'
